// extracted by mini-css-extract-plugin
module.exports = {"container":"OfsUserSelect_container__103mU"};